import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { VariantQualifier, provideDefaultConfig, provideDefaultConfigFactory, Config } from '@spartacus/core';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const PRODUCT_MULTI_DIMENSIONAL_SELECTOR_FEATURE = 'productMultiDimensionalSelector';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultProductMultiDimensionalConfig = {
  multiDimensional: {
    imageFormat: VariantQualifier.STYLE_SWATCH
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function defaultProductMultiDimensionalSelectorComponentsConfig() {
  return {
    featureModules: {
      [PRODUCT_MULTI_DIMENSIONAL_SELECTOR_FEATURE]: {
        cmsComponents: ['ProductMultiDimensionalSelectorComponent']
      }
    }
  };
}
let ProductMultiDimensionalSelectorRootModule = /*#__PURE__*/(() => {
  class ProductMultiDimensionalSelectorRootModule {
    static {
      this.ɵfac = function ProductMultiDimensionalSelectorRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductMultiDimensionalSelectorRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ProductMultiDimensionalSelectorRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig(defaultProductMultiDimensionalConfig), provideDefaultConfigFactory(defaultProductMultiDimensionalSelectorComponentsConfig)]
      });
    }
  }
  return ProductMultiDimensionalSelectorRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ProductMultiDimensionalConfig = /*#__PURE__*/(() => {
  class ProductMultiDimensionalConfig {
    static {
      this.ɵfac = function ProductMultiDimensionalConfig_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductMultiDimensionalConfig)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ProductMultiDimensionalConfig,
        factory: function ProductMultiDimensionalConfig_Factory(__ngFactoryType__) {
          let __ngConditionalFactory__ = null;
          if (__ngFactoryType__) {
            __ngConditionalFactory__ = new (__ngFactoryType__ || ProductMultiDimensionalConfig)();
          } else {
            __ngConditionalFactory__ = i0.ɵɵinject(Config);
          }
          return __ngConditionalFactory__;
        },
        providedIn: 'root'
      });
    }
  }
  return ProductMultiDimensionalConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PRODUCT_MULTI_DIMENSIONAL_SELECTOR_FEATURE, ProductMultiDimensionalConfig, ProductMultiDimensionalSelectorRootModule, defaultProductMultiDimensionalConfig, defaultProductMultiDimensionalSelectorComponentsConfig };
